import React, {useState} from 'react';
import VisitorDetailDialog from './VisitorDetailDialog';
import {VisitRequestDto} from "../../../../../../modules/vms/dto/VisitRequestDto";
import {FormattedMessage, useIntl} from "react-intl";
import {RequestVisitorDto} from "../../../../../../modules/vms/dto/RequestVisitorDto";
import {Card, CardHeader, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import AddIconButton from "../../../../../../components/buttons/AddIconButton";
import ModifyIconButton from "../../../../../../components/buttons/ModifyIconButton";
import DeleteIconButton from "../../../../../../components/buttons/DeleteIconButton";
import FormHelperText from '@mui/material/FormHelperText';
import VisitorQuickSelect from "../../../../components/VisitorQuickSelect";

export type VisitorListProps = {
    visitRequest: VisitRequestDto;
    messageMap: Map<string, string>;
    onChange: (name: string, value: any) => void;
};

const VisitorList: React.FC<VisitorListProps> = (props) => {
    const intl = useIntl();

    const [visitorDetailModalOpen, setVisitorDetailModalOpen] = useState(false);
    const [selectedRequestVisitor, setSelectedRequestVisitor] = useState(new RequestVisitorDto());
    const [selectedVisitorIndex, setSelectedVisitorIndex] = useState(-1);

    const handleDeleteVisitor = (index: number) => {
        // 拷贝一份副本操作再刷新，否则画面无法刷新
        const newRequestVisitors = [...props.visitRequest.visitors];
        newRequestVisitors.splice(index, 1);
        props.onChange('visitors', newRequestVisitors);
    };

    const handleShowVisitorAddModal = () => {
        setSelectedRequestVisitor(new RequestVisitorDto());
        setSelectedVisitorIndex(-1);
        setVisitorDetailModalOpen(true);
    };

    const handleShowVisitorModifyModal = (requestVisitor: RequestVisitorDto, index: number) => {
        setSelectedRequestVisitor(requestVisitor);
        setSelectedVisitorIndex(index);
        setVisitorDetailModalOpen(true);
    };

    const handleSaveVisitorDetail = (requestVisitor: RequestVisitorDto) => {
        if (selectedVisitorIndex >= 0) {
            const newVisitors = [...props.visitRequest.visitors];
            // 更新
            newVisitors[selectedVisitorIndex] = requestVisitor;
            console.log(newVisitors);
            props.onChange('visitors', newVisitors);
        } else {
            // 添加
            handleAddVisitor(requestVisitor);
        }
        setSelectedVisitorIndex(-1);
        setVisitorDetailModalOpen(false);
    };

    // 添加访客
    const handleAddVisitor = (item: RequestVisitorDto) => {
        const newRequestVisitors = [...props.visitRequest.visitors];
        newRequestVisitors.push(item);
        props.onChange('visitors', newRequestVisitors);
    }

    return (
        <div>
            <VisitorDetailDialog open={visitorDetailModalOpen}
                                 requestVisitor={selectedRequestVisitor}
                                 visitorIndex={selectedVisitorIndex}
                                 onCancel={() => setVisitorDetailModalOpen(false)}
                                 onOk={(requestVisitor) => handleSaveVisitorDetail(requestVisitor)}/>
            <Card>
                <CardHeader
                    action={
                        <AddIconButton onClick={() => handleShowVisitorAddModal()}/>
                    }
                    title={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_LIST'})}
                    subheader={
                        props.messageMap.has('visitors') ?
                            <FormHelperText error={true}> {props.messageMap.get('visitors')}</FormHelperText> : ''}
                />
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{intl.formatMessage({id: 'VMS_REQUEST_VISITOR_NAME'})}</TableCell>
                            <TableCell>{intl.formatMessage({id: 'VMS_REQUEST_VISITOR_MOBILE'})}</TableCell>
                            {/*<TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_EMAIL"})}</TableCell>*/}
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_COMPANY"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_ID_NUMBER"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: "VMS_REQUEST_VISITOR_PLATE_NUMBER"})}</TableCell>
                            <TableCell>{intl.formatMessage({id: 'COMMON_ACTION'})}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.visitRequest.visitors.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell>{row.lastName + ' ' + row.firstName}</TableCell>
                                <TableCell>{row.mobile}</TableCell>
                                {/*<TableCell>{row.email}</TableCell>*/}
                                <TableCell>{row.company}</TableCell>
                                <TableCell>{row.idNumber}</TableCell>
                                <TableCell>{row.plateNumber}</TableCell>
                                <TableCell>
                                    <ModifyIconButton onClick={() => handleShowVisitorModifyModal(row, index)}/>
                                    <DeleteIconButton onClick={() => handleDeleteVisitor(index)}/>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Card>

            <br/>
            <VisitorQuickSelect onSelect={(item) => handleAddVisitor(item)}/>
        </div>
    );
};

export default VisitorList;
